import Lottie from 'react-lottie'
import ReactMarkdown from 'react-markdown'
import cn from 'classnames'

import typingAnimation from '../../assets/animations/typing.json'

import './style.css'

const ChatBox = ({ text, isConsultant, isTyping }) => {
  return (
    <div className={cn('flex w-full', { 'justify-end': !isConsultant })}>
      <div
        className={cn('px-3 py-1 rounded-lg max-w-4/5 inline-block app-chat-box', {
          'rounded-tl-none': isConsultant,
          'rounded-tr-none': !isConsultant,
          'bg-gray-75': isConsultant,
          'bg-red-350': !isConsultant
        })}>
        {isTyping ? (
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: typingAnimation,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            height={30}
            width={50}
          />
        ) : (
            <div className={cn('text-sm', {
              'text-coolGray-950': isConsultant,
              'text-white': !isConsultant
            })}>
              <ReactMarkdown>
                {text}
              </ReactMarkdown>
            </div>
          )}
      </div>
    </div>
  )
}

export default ChatBox
